import React, { useState, useMemo } from 'react';

const QUICK = [2, 5, 10, 20];

function appendDigit(current, digit) {
  if (digit === '.') {
    if (current.includes('.')) return current;
    if (current === '') return '0.';
    return current + '.';
  }
  if (current === '0') return digit === '0' ? '0' : digit;
  const dotIdx = current.indexOf('.');
  if (dotIdx >= 0 && current.length - dotIdx > 2) return current;
  if (current.replace('.', '').length >= 6) return current;
  return current + digit;
}

function backspace(current) {
  return current.length <= 1 ? '' : current.slice(0, -1);
}

function parseAmount(raw) {
  const amount = Math.round(Number(raw) * 100) / 100;
  if (!Number.isFinite(amount)) return null;
  return amount;
}

export default function PosDonationModal({ item, onConfirm, onCancel }) {
  const suggested = Number(item?.price) > 0 ? Number(item.price) : null;
  const [raw, setRaw] = useState('');

  const amount = useMemo(() => parseAmount(raw), [raw]);
  const canAdd = amount !== null && amount >= 0.01 && amount <= 9999.99;

  const submit = (e) => {
    e?.preventDefault?.();
    if (!canAdd) return;
    onConfirm(amount);
  };

  return (
    <div className="pos-modal-backdrop" onClick={onCancel}>
      <form
        className="pos-modal pos-donation-modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
      >
        <h2 className="pos-modal-title">{item?.name || 'Donation'}</h2>
        <p className="pos-modal-subtitle">
          Orban / holy bread — tap the amount on the keypad.
        </p>

        <div className="pos-donation-display" aria-live="polite">
          <span className="pos-donation-display-label">Amount</span>
          <span className="pos-donation-display-value">
            {raw === '' ? '$0.00' : `$${raw}`}
          </span>
        </div>

        <div className="pos-donation-quick">
          {(suggested && !QUICK.includes(suggested) ? [suggested, ...QUICK] : QUICK).map((n) => (
            <button
              key={n}
              type="button"
              className={`pos-tender-chip${amount === n ? ' pos-tender-chip-exact' : ''}`}
              onClick={() => setRaw(Number.isInteger(n) ? String(n) : n.toFixed(2))}
            >
              ${Number.isInteger(n) ? n : n.toFixed(2)}
            </button>
          ))}
        </div>

        <div className="pos-tender-numpad pos-donation-numpad">
          {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((k) => (
            <button
              key={k}
              type="button"
              className="pos-tender-key"
              onClick={() => setRaw((prev) => appendDigit(prev, k))}
            >
              {k}
            </button>
          ))}
          <button
            type="button"
            className="pos-tender-key pos-tender-key-fn"
            onClick={() => setRaw((prev) => appendDigit(prev, '.'))}
          >
            .
          </button>
          <button
            type="button"
            className="pos-tender-key"
            onClick={() => setRaw((prev) => appendDigit(prev, '0'))}
          >
            0
          </button>
          <button
            type="button"
            className="pos-tender-key pos-tender-key-fn"
            onClick={() => setRaw((prev) => backspace(prev))}
            aria-label="Backspace"
          >
            &larr;
          </button>
        </div>

        <div className="pos-modal-actions">
          <button type="button" className="pos-modal-btn pos-modal-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="submit"
            className="pos-modal-btn pos-modal-btn-primary"
            disabled={!canAdd}
          >
            {canAdd ? `Add $${amount.toFixed(2)}` : 'Enter an amount'}
          </button>
        </div>
      </form>
    </div>
  );
}
